import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=118814c8&"
import script from "./Preloader.vue?vue&type=script&lang=js&"
export * from "./Preloader.vue?vue&type=script&lang=js&"
import style0 from "./Preloader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports